import { PluckingListDto } from './MooringProductionOrderPlucking';

export class GridLineProductionItemDto {
  public GridLineId: number;
  public GridLineProductionId?: number;

  public CompletedById?: string;
  public CompletedBy?: string;
  public CompletedAt?: Date;

  public StartBuoyId: number;
  public StartBuoyName: string;
  public StartBuoyRow: number;
  public StartBuoyColumn: number;
  public MountedOnStartBuoy: boolean;

  public EndBuoyId: number;
  public EndBuoyName: string;
  public EndBuoyRow: number;
  public EndBuoyColumn: number;
  public MountedOnEndBuoy: boolean;

  public MoorlogNo: string;
  public AnalysisNo: string;
}

export class GridLineProductionDto {
  public MoorlogNo: string;
  public AnalysisNo: string;

  public Articles: PluckingListDto[] = [];
}

export class UpdateGridLineProductionDto {
  public GridLineId: number;

  public Completed: boolean;
  public MountedOnStartBuoy: boolean;
  public MountedOnEndBuoy: boolean;
}
